import "../css/style.css";
import { Keyboard } from "./keyboard";
new Keyboard();
